import React, { useState, useEffect } from "react";
import { Form, Input } from "../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  Grid,
  Typography,
  IconButton,
  InputAdornment,
  Button,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import * as Yup from "yup";
import { auth, db } from "../../firebase/config";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import { setLoading } from "../../redux/publicReducer/actions";
import { useDispatch } from "react-redux";

export const ClientRegister = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { state } = useLocation();

  console.log(state, "state");
  const history = useHistory();
  const initialValues = {
    email: "",
    name: "",
    password: "",
    confirm: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Enter a valid email")
      .required("Email is required"),
    name: Yup.string().required("Please enter your name"),
    password: Yup.string()
      .required("Please enter your password")
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()-_=+{};:,<.>]){1})(?=.*d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        "Password must contain at least 8 characters, one uppercase, one number and one special case character"
      ),
    confirm: Yup.string()
      .oneOf([Yup.ref("password"), null], "Password does not match")
      .required("Confirm password is required")
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()-_=+{};:,<.>]){1})(?=.*d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        "Password must contain at least 8 characters, one uppercase, one number and one special case character"
      ),
  });
  const methods = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const handleSubmit = (data) => {
    dispatch(setLoading(true));
    console.log(data);
    auth
      .createUserWithEmailAndPassword(data.email, data.password)
      .then((user) => {
        if (user) {
          db.collection("users")
            .doc(auth.currentUser?.uid)
            .set({
              email: data.email,
              name: data.name,
              userType: "CUSTOMER",
            })
            .then(() => {
              toast.success("Account successfully created !");
              dispatch(setLoading(false));
              if (state?.restaurantId) {
                history.push(`/${state?.restaurantId}/checkout`);
              } else {
                history.push("/");
              }
            });
        }
      })
      .catch((error) => {
        toast.error(error?.message);
      });
  };

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item xs={12} md={6} lg={4}>
          <Paper
            style={{
              padding: "1rem",
              minHeight: "50vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              borderRadius: "10px",
            }}
          >
            <Typography
              style={{ textAlign: "center", margin: "1rem 0rem" }}
              variant={"h4"}
              color="primary"
            >
              Create your account
            </Typography>
            <Form onSubmit={handleSubmit} provider={methods}>
              <Input name="email" label="Email" variant="outlined" />
              <Input name="name" label="Your name" variant="outlined" />
              <Input
                name="password"
                label="Password"
                type={!showPassword ? "password" : "text"}
                variant="outlined"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {!showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <Input
                name="confirm"
                label="Confirm Password"
                type={!showPassword ? "password" : "text"}
                variant="outlined"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {!showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <div style={{ marginTop: "0.5rem" }}>
                <Button variant="contained" color="primary" type="submit">
                  Register
                </Button>
              </div>
            </Form>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
